import React, { useEffect, useState, useCallback } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faSave,
  faTimesCircle,
  faSort,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import api from "../../services/client/api";
import { StepContainer, ModalWrapper, StepTexth4 } from "./styles";
import { Label, Button, Alert, Spinner, Fade, Table } from "reactstrap";
import { SessionManager } from "../../utils/functions";
const Laudos = ({ token, patient, onClose, username, report }) => {
  const [desfechos, setDesfechos] = useState([]);
  const [dataDesfecho, setDataDesfecho] = useState("");
  const [selectedDesfecho, setSelectedDesfecho] = useState(null);
  const [alertInsert, setAlertInsert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const session = SessionManager();
  const [downloading, setDownloading] = useState(null);
  const [order, setOrder] = useState("desc");
  useEffect(() => {
    const fetchLaudos = async () => {
      try {
        const response = await api()
          .user()
          .GetTumorBoardReports(token, patient.CodPaciente, username);

        if (response.status === 200) {
          setDesfechos(response.output);
        }
      } catch (err) {
        console.error("Erro ao buscar desfechos:", err);
      }
    };

    fetchLaudos();
  }, [token]);

  useEffect(() => {
    if (report) {
      if (report.CodDesfecho != null) {
        setSelectedDesfecho(Number(report.CodDesfecho));
      }

      if (report.DtaDesfecho) {
        // usa a data vinda da API
        const formattedDate = new Date(report.DtaDesfecho)
          .toISOString()
          .split("T")[0];

        setDataDesfecho(formattedDate);
      } else {
        // usa a data atual
        const today = new Date().toISOString().split("T")[0];
        setDataDesfecho(today);
      }
    }
  }, [report]);

  const sortedDesfechos = [...desfechos].sort((a, b) => {
    const dateA = new Date(a.DtaSolicitacao);
    const dateB = new Date(b.DtaSolicitacao);
    return order === "desc" ? dateB - dateA : dateA - dateB;
  });

  const download = useCallback(
    async (numberReport, typeReport) => {
      setDownloading(numberReport);

      try {
        const response = await api()
          .report()
          .downloadTumorBoard(token, numberReport, typeReport);

        if (response.status === 401) {
          return session.logoff();
        }

        if (response.status === 200) {
          window.open(response.output);
        }
      } catch (error) {
        console.error("Erro no download:", error);
      } finally {
        setDownloading(null);
      }
    },
    [session, token],
  );

  return (
    <div style={{ position: "relative" }}>
      <ModalWrapper>
        <button
          onClick={onClose}
          style={{
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            border: "none",
            background: "#0C2B6E",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 9999,
          }}
        >
          <FontAwesomeIcon icon={faTimesCircle} />
        </button>

        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          ></div>
          <StepContainer>
            <StepTexth4 style={{ marginTop: 25 }}>
              <b>Selecione o laudo que deseja visualizar:</b>
            </StepTexth4>
          </StepContainer>

          {errorMessage && (
            <Alert color="danger" style={{ textAlign: "center" }}>
              <b>{errorMessage}</b>
            </Alert>
          )}
        </>

        {desfechos.length > 0 ? (
          <Table bordered hover responsive style={{ marginTop: 20 }}>
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>Código</th>
                <th
                  style={{
                    textAlign: "center",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                  onClick={() => setOrder(order === "desc" ? "asc" : "desc")}
                >
                  Data{" "}
                  <FontAwesomeIcon
                    icon={faSort}
                    style={{
                      marginLeft: 3,
                      fontSize: "1.0rem",
                      opacity: 0.7,
                    }}
                  />
                </th>
                <th style={{ textAlign: "center" }}>Ação</th>
              </tr>
            </thead>
            <tbody>
              {sortedDesfechos.map((item, index) => (
                <tr key={index}>
                  <td style={{ textAlign: "center" }}>{item.CodRequisicao}</td>
                  <td style={{ textAlign: "center" }}>
                    {new Date(item.DtaSolicitacao).toLocaleDateString("pt-BR")}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() =>
                        download(item.CodRequisicao, item.TipoForm)
                      }
                      disabled={downloading === item.CodRequisicao}
                    >
                      {downloading === item.CodRequisicao ? (
                        <Spinner size="sm" />
                      ) : (
                        "Download"
                      )}
                      <FontAwesomeIcon
                        icon={faDownload}
                        style={{
                          marginLeft: 5,
                        }}
                      />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Spinner />
          </div>
        )}
      </ModalWrapper>
    </div>
  );
};

export default Laudos;
